export const explorerBaseUrls = {
    ETH: 'https://etherscan.io',
    POLYGON: 'https://polygonscan.com',
    AVALANCHE: 'https://snowtrace.io',
    ARBITRUM: 'https://arbiscan.io',
    BINANCE: 'https://bscscan.com',
    OPTIMISM: 'https://optimistic.etherscan.io',
    FANTOM: 'https://ftmscan.com',
    SOLANA: 'https://solscan.io',
    APTOS: 'https://explorer.aptoslabs.com',
    NEO: 'https://neo3.neotube.io',
    SUI: 'https://suiexplorer.com/?network=mainnet',
    FUSE: 'https://explorer.fuse.io',
    MUMBAI: 'https://mumbai.polygonscan.com',
    METIS: 'https://andromeda-explorer.metis.io',
    'METIS-TESTNET': 'https://sepolia.explorer.metisdevops.link',
    MANTLE: 'https://explorer.mantle.xyz',
    'MANTLE-TESTNET': 'https://explorer.testnet.mantle.xyz',
    MANTA: 'https://pacific-explorer.manta.network',
    'MANTA-TESTNET': 'https://manta-testnet.calderaexplorer.xyz',
};
export const txnBaseUrl = {
    ETH: `${explorerBaseUrls.ETH}/tx`, // /txHash
    POLYGON: `${explorerBaseUrls.POLYGON}/tx`,
    AVALANCHE: `${explorerBaseUrls.AVALANCHE}/tx`,
    ARBITRUM: `${explorerBaseUrls.ARBITRUM}/tx`,
    BINANCE: `${explorerBaseUrls.BINANCE}/tx`,
    OPTIMISM: `${explorerBaseUrls.OPTIMISM}/tx`,
    FANTOM: `${explorerBaseUrls.FANTOM}/tx`,
    FUSE: `${explorerBaseUrls.FUSE}/tx`,
    MUMBAI: `${explorerBaseUrls.MUMBAI}/tx`,
    METIS: `${explorerBaseUrls.METIS}/tx`,
    'METIS-TESTNET': `${explorerBaseUrls['METIS-TESTNET']}/tx`,
    MANTLE: `${explorerBaseUrls.MANTLE}/tx`,
    'MANTLE-TESTNET': `${explorerBaseUrls['MANTLE-TESTNET']}/tx`,
    MANTA: `${explorerBaseUrls.MANTA}/tx`,
    'MANTA-TESTNET': `${explorerBaseUrls['MANTA-TESTNET']}/tx`,
};
export const nativeTokenDetails = {
    ETH: {
        name: 'Ether',
        symbol: 'ETH',
        logoUrl: 'https://www.datocms-assets.com/86369/1669619533-ethereum.png',
    },
    POLYGON: {
        name: 'Matic Token',
        symbol: 'MATIC',
        logoUrl: 'https://logos.covalenthq.com/tokens/1/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0.png',
    },
    AVALANCHE: {
        name: 'Avalanche Coin',
        symbol: 'AVAX',
        logoUrl: 'https://www.datocms-assets.com/86369/1686152997-avalanche-colour.png',
    },
    ARBITRUM: {
        name: 'Arbitrum Mainnet Ether',
        symbol: 'ETH',
        logoUrl: 'https://www.datocms-assets.com/86369/1669925028-arbitrum.png',
    },
    BINANCE: {
        name: 'Binance Coin',
        symbol: 'BNB',
        logoUrl: 'https://www.datocms-assets.com/86369/1670003837-biance-smart-chain-colour.png',
    },
    OPTIMISM: {
        name: 'Ether',
        symbol: 'ETH',
        logoUrl: 'https://www.datocms-assets.com/86369/1670347461-optimisim-colour.png',
    },
    FANTOM: {
        name: 'Fantom',
        symbol: 'FTM',
        logoUrl: 'https://www.datocms-assets.com/86369/1669925359-fantom-1.png',
    },
    FUSE: {
        name: 'Fuse',
        symbol: 'FUSE',
        logoUrl: 'https://assets.coingecko.com/coins/images/10347/standard/fuse.png',
    },
    MUMBAI: {
        name: 'Matic Token',
        symbol: 'MATIC',
        logoUrl: 'https://logos.covalenthq.com/tokens/1/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0.png',
    },
    METIS: {
        name: 'Metis Token',
        symbol: 'METIS',
        logoUrl: 'https://static.tria.so/chain-logo-w/Metis.webp',
    },
    'METIS-TESTNET': {
        name: 'Metis Token',
        symbol: 'METIS',
        logoUrl: 'https://static.tria.so/chain-logo-w/Metis.webp',
    },
    MANTLE: {
        name: 'Mantle',
        symbol: 'MNT',
        logoUrl: 'https://static.tria.so/chain-logo-w/Mantle.webp',
    },
    'MANTLE-TESTNET': {
        name: 'Mantle',
        symbol: 'MNT',
        logoUrl: 'https://static.tria.so/chain-logo-w/Mantle.webp',
    },
    MANTA: {
        name: 'Ether',
        symbol: 'ETH',
        logoUrl: 'https://static.tria.so/chain-logo-w/Manta.webp',
    },
    'MANTA-TESTNET': {
        name: 'Ether',
        symbol: 'ETH',
        logoUrl: 'https://static.tria.so/chain-logo-w/Manta.webp',
    },
};
